import { api } from '../apiClient'
import type { SparqlSearchCriteria } from '../apiTypes'

// SPARQL 쿼리 관련 API
export const sparqlAPI = {
  getProductCostSummary: () => api.get('/api/sparql/product-cost-summary'),
  getProcessResourceConsumption: () =>
    api.get('/api/sparql/process-resource-consumption'),
  getResourceEfficiency: () => api.get('/api/sparql/resource-efficiency'),
  getComplexRelationships: (productFilter?: string) =>
    api.get(
      `/api/sparql/complex-relationships${productFilter ? `?product_filter=${productFilter}` : ''}`
    ),
  getCostBreakdown: () => api.get('/api/sparql/cost-breakdown'),
  searchByCriteria: (criteria: SparqlSearchCriteria) =>
    api.post('/api/sparql/search', criteria),
  executeCustomQuery: (sparql: string) =>
    api.post('/api/sparql/custom-query', { sparql }),
  getQueryStats: () => api.get('/api/sparql/stats'),
  healthCheck: () => api.get('/api/sparql/health'),
  executeQuery: (sparql: string) =>
    api.post('/api/sparql/query', { query: sparql }),
}

// 원가 분석 API (v6.2 Named Graph Layer)
export const costAnalysisAPI = {
  getSummary: (projectId: string, dimensionValues: Record<string, string>) =>
    api.get(`/cost-analysis/${projectId}/summary`, {
      params: { dimension_values: JSON.stringify(dimensionValues) },
    }),
  calculate: (
    projectId: string,
    data: {
      dimension_values: Record<string, string>
      calculation_type?: string
      include_overhead?: boolean
    }
  ) => api.post(`/cost-analysis/${projectId}/calculate`, data),
  getBreakdown: (
    projectId: string,
    dimensionValues: Record<string, string>,
    productId?: string
  ) =>
    api.get(`/cost-analysis/${projectId}/breakdown`, {
      params: {
        dimension_values: JSON.stringify(dimensionValues),
        ...(productId && { product_id: productId }),
      },
    }),
  getFlow: (projectId: string, dimensionValues?: Record<string, string>) =>
    api.get(`/cost-analysis/${projectId}/flow`, {
      params: dimensionValues
        ? { dimension_values: JSON.stringify(dimensionValues) }
        : {},
    }),
  compareDimensions: (
    projectId: string,
    dim1: Record<string, string>,
    dim2: Record<string, string>
  ) =>
    api.post(`/cost-analysis/${projectId}/compare-dimensions`, { dim1, dim2 }),
}
